import { __rest } from "tslib";
import React from 'react';
import { Content } from '..';
import { FullScreenMedia, Media, MetaInfo } from '../../components';
import { block } from '../../utils';
import { getLayoutItemLinks, hasFullscreen, showFullscreenIcon } from './utils';
import './LayoutItem.css';
const b = block('layout-item');
const LayoutItem = (_a) => {
    var _b = _a.content, { links } = _b, content = __rest(_b, ["links"]), { metaInfo, media, border, fullScreen, fullscreen, className } = _a;
    return (React.createElement("div", { className: b(null, className) },
        (fullScreen || fullscreen) && hasFullscreen(media) ? (React.createElement(FullScreenMedia, { showFullscreenIcon: showFullscreenIcon(media) }, (_a = {}) => {
            var { className: mediaClassName, fullScreen: _fullScreen } = _a, fullscreenMediaProps = __rest(_a, ["className", "fullScreen"]);
            return (React.createElement(Media, Object.assign({}, media, fullscreenMediaProps, { className: b('media', { border }, mediaClassName) })));
        })) : (React.createElement(Media, Object.assign({}, media, { className: b('media', { border }) }))),
        metaInfo && React.createElement(MetaInfo, { items: metaInfo, className: b('meta-info') }),
        React.createElement("div", { className: b('content') },
            React.createElement(Content, Object.assign({}, content, { links: getLayoutItemLinks(links), size: "s", colSizes: { all: 12, md: 12 } })))));
};
export default LayoutItem;
